import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({ providedIn: 'root' })

export class CardIconeTituloLinkContainerService {

  private host =
    environment.configCMS.endPointAPI + environment.configCMS.endPointAPP;

  constructor(private router: Router, private http: HttpClient) {}

  public getCardIconeTituloLink(id: string): Observable<any> {
    return this.getCardIconeTituloLinkContents(id).pipe(
      map(res => this.buildResponseCardIconeTituloLinkObject(this.extractResult(res))),
      catchError(error => {
        console.log('error', error);
        this.router.navigate(['/nao-encontrado']);
        return of(null);
      })
    );
  }

  private extractResult(res) {
    return res.data.queryCardIconeTituloLinkContents[0].flatData;
  }

  private getCardIconeTituloLinkContents(id: string): Observable<any> {
    const payload = {
      query: `
      {
        queryCardIconeTituloLinkContents(filter: "id eq '${id}'") {
          flatData {
            nome
            textoDestaque
            icone {
              url
            }
            uRL
            pagina {
              data {
                slug {
                  iv
                }
              }
            }
            documento {
              url
            }
            mostraLink
          }
        }
      }`
    };

    return this.send(payload);
  }

  private buildResponseCardIconeTituloLinkObject(card: any) {
    return {
      highlightText: card.textoDestaque ? card.textoDestaque : null,
      icon: card.icone && card.icone[0]
          ? card.icone[0].url
          : null,
      externalLink: card.uRL
          ? card.uRL
          : null,
      page: card.pagina && card.pagina.length > 0
          ? '/paginas/' + card.pagina[0].data.slug.iv
          : null,
      document: card.documento && card.documento[0]
          ? card.documento[0].url
          : null,
      hasTxtUrl: card.mostraLink
    };
  }

  private send(payload): Observable<any> {
    const url = `${this.host}graphql`;
    return this.http.post(url, payload);
  }
}
